export const authKeys = {
  me: ["auth", "me"] as const,
};

export const agentKeys = {
  all: ["agents"] as const,
  list: () => [...agentKeys.all] as const,
  detail: (id: string) => ["agents", id] as const,
  stats: (id: string) => ["agents", id, "stats"] as const,
  timeSeries: (
    id: string,
    params: { metric: string; groupBy: string; range: string }
  ) => ["agents", id, "stats", "time-series", params] as const,
  conversations: (id: string) => ["agents", id, "conversations"] as const,
  conversation: (agentId: string, convId: string) =>
    ["agents", agentId, "conversations", convId] as const,
  sources: (id: string) => ["agents", id, "sources"] as const,
  sourceChunks: (agentId: string, sourceId: string) =>
    ["agents", agentId, "sources", sourceId, "chunks"] as const,
};

export const statsKey = ["stats"] as const;
